import { queryOptions } from '@tanstack/react-query'
import { Pagination } from '@thinknimble/tn-models'
import { expenseSearchApi } from './api'
import { ExpenseSearchFilter } from './models'

export const expenseSearchQueries = {
  all: () => ['expense-searches'],
  retrieve: (id: string) => {
    return queryOptions({
      queryKey: [...expenseSearchQueries.all(), id],
      queryFn: () => expenseSearchApi.retrieve(id),
      enabled: Boolean(id),
    })
  },
  list: ({
    filters,
    pagination,
    paginationCallback,
  }: {
    filters?: Partial<ExpenseSearchFilter>
    pagination?: Pagination
    paginationCallback?: (pagination: Pagination) => void
  }) => {
    return queryOptions({
      queryKey: [...expenseSearchQueries.all(), { filters, pagination }],
      queryFn: async () => {
        const res = await expenseSearchApi.list({
          filters,
          pagination,
        })
        const serverPagination = new Pagination({ ...res, totalCount: res.count })
        paginationCallback?.(serverPagination)
        return res
      },
      enabled: true,
    })
  },
}
